import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for might be in another castle.</p>
    </div>
  );
};

export default NotFound;
